import React, { useEffect } from 'react';
import lottie from 'lottie-web';

export const Lottie = props => {
  const {
    getInstance = () => {},
    animationData,
    className = 'lottie-animation',
    container = 'lottie-animation',
    autoplay = true,
    loop = true,
    delay = false,
  } = props;
  useEffect(() => {
    const lottieInstance = lottie.loadAnimation({
      container: document.getElementById(container),
      renderer: 'svg',
      loop,
      autoplay: delay ? false : autoplay,
      animationData,
    });
    getInstance(lottieInstance);
    if (delay) setTimeout(() => lottieInstance.play(), parseInt(delay, 10));
  }, []);

  return <div id={container} className={className} />;
};
